<template>
    <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M5.59996 10.6C7.44996 8.99 9.84996 8 12.5 8C17.15 8 21.08 11.03 22.46 15.22L20.1 16C19.05 12.81 16.05 10.5 12.5 10.5C10.55 10.5 8.76996 11.22 7.37996 12.38L11 16H1.99996V7L5.59996 10.6Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
export default {};
</script>

<style></style>
